import { ChevronRight } from "@mui/icons-material";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import React, { useContext } from "react";
import { useTranslation } from "react-i18next";
import { UIContext } from "../../../context/UIContext";
import { UserContext } from "../../../context/UserContext";
import { formatValue } from "../../../helpers/helpers";
import { TroncRow } from "../../../models/tronc";


export interface TroncMobileCardProps {
  labelId: string; 
  row: TroncRow; 
  isLastRow: boolean; 
  currency: string;
}

const TroncMobileCard = ({labelId, row, isLastRow, currency} : TroncMobileCardProps) => {
const { t } = useTranslation();
const { colorMode } = useContext(UIContext);
const { locale } = useContext(UserContext);

return (
  <Box
    key={`mobile-card-outer-${labelId}`}
    sx={{
      display: 'flex',
      flexDirection: 'row', // left vs right
      justifyContent: 'space-between',
      alignItems: 'center',
      paddingY: '1rem',
      paddingLeft: '1rem',
      backgroundColor: (theme) =>
        colorMode === 'light'
          ? theme?.palette?.common?.white
          : theme?.palette?.common?.black,
      borderTop: (theme) =>
        `1px ${
          colorMode === 'light'
            ? theme?.palette?.grey?.['12p']
            : theme?.palette?.grey?.['23p']
        } solid`,
      borderBottom: isLastRow
        ? (theme) =>
            `1px ${
              colorMode === 'light'
                ? theme?.palette?.grey?.['12p']
                : theme?.palette?.grey?.['23p']
            } solid`
          : 0,

    }}
  >
    <Box
      key={`mobile-card-left-${labelId}`}
      sx={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
      }}
    >
      {row.staffName && (
        <Typography
          key={`mobile-card-staff-${labelId}`}
          sx={{ fontSize: '16px' }}
        >
          {row.staffName}
        </Typography>
      )}
      <Typography
        key={`mobile-card-hours-${labelId}`}
        sx={{ fontSize: '14px', color: 'text.secondary' }}
      >
        {t('screens.troncReport.fields.hoursAcronym', { hours: `${row.hours}` })}
      </Typography>
    </Box>

    <Box
      key={`mobile-card-right-${labelId}`}
      sx={{
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        gap: '0.5rem',
        paddingRight: '1rem',
      }}
    >
      <Typography
        key={`mobile-card-amount-${labelId}`}
        sx={{ fontWeight: 600, fontSize: '16px' }}
      >
        {formatValue(row.totalTronc, true, currency, locale)}
      </Typography>
      <ChevronRight key={`mobile-card-icon-${labelId}`} 
        style={{color: '#595959'}}
      />
    </Box>
  </Box>
);
}

export default TroncMobileCard;
